import { lerCache } from '@/libs/navegacao/cacheContadores';

// Semeia de forma SÍNCRONA a partir do localStorage: do segundo acesso em
// diante o menu já nasce na forma final, sem piscar itens que vão sumir.
const inicial = lerCache();

export default {
    namespaced: true,
    state: {
        contadores: inicial ? inicial.contadores : null,
    },
    mutations: {
        definirContadores(state, contadores) {
            state.contadores = { ...(state.contadores || {}), ...contadores };
        },
        definirContador(state, { chave, valor }) {
            state.contadores = { ...(state.contadores || {}), [chave]: valor };
        },
        limpar(state) {
            state.contadores = null;
        },
    },
};
